<template lang="pug">
.guide
  .guide-kv
    .guide-kv-image
      img.guide-kv-img(src="/static/images/manual/guide_kv.webp")
    h2.guide-kv-text 通知設定
  .guide-breadcrumb
    .guide-breadcrumb-child
      p.guide-breadcrumb-child-current
  .guide-functionList(v-for="item in article")
    .guide-headLineWrap
      h3.guide-headLineWrap-headLine {{ item.titleOverviewParent }}
    ul.guide-articleGroup
      li.guide-articleList(v-for="itemArticleLink in item.list")
        a.guide-articleLinkOuter(:href="itemArticleLink.link")
          .guide-articleLinkInner
            .guide-articleLinkInner-textArea
              h4.guide-articleLinkInner-textArea-title {{ itemArticleLink.titleList }}
              p.guide-articleLinkInner-textArea-text {{ itemArticleLink.textList }}
            .guide-articleLinkInner-arrowImage
</template>

<script>
export default {
  data () {
    return {
      guide: '',
      job_notification_settings: '',
      article: [
          {
            titleOverviewParent: '通知メール設定',
            list: [
              {
                link: '/guide/job_notification_settings/1-a',
                titleList: '通知機能の概要',
                textList: '「通知設定」で設定した条件・タイミングでメールを送信する機能です。',
              },
              {
                link: '/guide/job_notification_settings/1-b',
                titleList: '検索条件の保存',
                textList: 'まずはどんな求人を通知するかを決める必要があります。',
              },
              {
                link: '/guide/job_notification_settings/1-c',
                titleList: '通知設定の作成',
                textList: '「検索条件の保存」が完了したら、通知設定の作成を行いましょう。',
              },
              {
                link: '/guide/job_notification_settings/1-d',
                titleList: '通知設定の変更',
                textList: '保存した通知設定を後から変えようとした場合、1つ注意点があります。',
              },
            ],
          },
          {
            titleOverviewParent: '取引先の求人通知',
            list: [
              {
                link: '/guide/job_notification_settings/2-a',
                titleList: '通知される求人のイメージ',
                textList: '営業ターゲットになる領域で、取引先の求人のみを通知することも可能です。',
              },
              {
                link: '/guide/job_notification_settings/2-b',
                titleList: '取引先の登録',
                textList: 'まずは、取引先の社名を登録するところから始めましょう。',
              },
              {
                link: '/guide/job_notification_settings/2-c',
                titleList: '社数が多い場合の対応方法',
                textList: '取引先などの通知を受け取りたい特定の企業が1,000社を超える場合には、複数アカウントで会社を切り分ける形でご利用ください。',
              },
            ],
          },
          {
            titleOverviewParent: '取引先と新規の同時通知',
            list: [
              {
                link: '/guide/job_notification_settings/3-a',
                titleList: '通知される求人のイメージ',
                textList: '複数アカウントを活用すれば、営業ターゲットになる領域で、取引先、取引先以外のそれぞれの求人を同時に通知することも可能です。',
              },
              {
                link: '/guide/job_notification_settings/3-b',
                titleList: 'アカウントごとの役割整理',
                textList: '複数アカウントで別々の設定をすることになるため、まず初めにどのアカウントで何を設定するかを可視化しておく必要があります。',
              },
              {
                link: '/guide/job_notification_settings/3-c',
                titleList: '取引先の除外',
                textList: '除外する場合も登録と同様に、取引先の社名を登録するところから始めましょう。',
              },
              {
                link: '/guide/job_notification_settings/3-d',
                titleList: '取引先の登録',
                textList: 'まずは、取引先の社名を登録するところから始めましょう。',
              },
            ],
          },
        ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/guide/job-notification-settings/JobNotificationSettings.vue